module.exports = __webpack_public_path__ + "img/30.fbe1f7f1.jpg";